export const submitModalCart = (form, billingAddress, shippingAddress, shippingMode, url, useQCPayment) => {
    form.shippingModeId.value = shippingMode;
    form.billingAddressId.value = billingAddress;
    form.shippingAddressId.value = shippingAddress;
    form.URL.value = url;
    if(useQCPayment){
        
    	form.CardType2.value = 'savedCard2';
    	form.skipCheck.value = 'true';
    	form.hasQuickCheckout.value = 'true';
    	form.isPIAddNeeded.value = 'Y';
    	form.editAddressId.value = billingAddress;
    	// WWW-19070 - changed .html() to .text() on both #qcEmail and #qcPhone
        form.email.value = $('#qcEmail').text();
        form.phone.value = $('#qcPhone').text();
    }
    $('.quick-checkout-modal-view').modal('hide');
    
    if(url == "OrderItemDisplay"){
    	$("input[id^=subFrequencyRadio_once]").prop("checked","checked");
    	$("select[name^=tieShipCode]").val("");
    }
    form.submit();
};
